var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-item__custom"},[_c(_vm.config.component_name,{key:_vm.$$ActivatedPreview.__key,tag:"component",attrs:{"preview":_vm.$$ActivatedPreview}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }